import { emitSheetOpen } from './SheetOpenEvents';

export const reloadVouchersSheet = (): void => {
    const sheetContentParentElement = document.querySelector('#sheet_content');
    const sheetContentId = sheetContentParentElement?.getAttribute('data-sheet-content-id') || '';

    const path = '/order/vouchersSheet?initial=false';
    fetch(path)
        .then(response => response.text())
        .then(sheetContent => {
            const dummyContainer = document.createElement('div');
            dummyContainer.innerHTML = sheetContent;

            const vouchersTab = document.querySelector('#vouchersTab'); //
            const oldVouchersSheetContent = document.querySelector('#sheet_content .or_js_voucherSheet__content');
            const newVouchersSheetContent = dummyContainer.querySelector('.or_js_voucherSheet__content');

            if (vouchersTab && oldVouchersSheetContent && newVouchersSheetContent) {
                const maybeExistingRedDot = vouchersTab?.querySelector('.or_couponsAndVouchersSheet__segmentedPickerDot');
                const hasUnusedVouchers = newVouchersSheetContent?.querySelector('.or_js_voucherSheet__note--check-failed') !== null;
                const hasInactiveCompensationCodes = newVouchersSheetContent?.querySelector('.or_js_compensationCodeActivateButton') !== null;
                const shouldHideRedDot = newVouchersSheetContent?.getAttribute('data-show-red-dot') === 'false';

                if (hasUnusedVouchers || hasInactiveCompensationCodes) {
                    if (maybeExistingRedDot) {
                        /*                                          */
                        maybeExistingRedDot.removeAttribute('style');
                    } else if (!shouldHideRedDot && vouchersTab) {
                        /*                                       */
                        vouchersTab.insertAdjacentHTML(
                            'afterbegin',
                            `<div class="or_couponsAndVouchersSheet__segmentedPickerDot">
                                <svg xmlns="http:/*                                                                      */
                                    <circle cx="3.25" cy="3" r="3" fill="#F00020"/>
                                </svg>
                            </div>`
                        );
                    }
                } else {
                    /*                                               */
                    maybeExistingRedDot?.setAttribute('style', 'display: none');
                }

                oldVouchersSheetContent.replaceWith(newVouchersSheetContent);
                emitSheetOpen({ id: sheetContentId });
            }
        })
        .catch(error => {
            console.error(`Error loading sheet from /order/vouchersSheet: ${error}`); /*   */
        });
};
